import React from "react"
import { Link } from "gatsby"

import Health from "assets/icons/health.svg"
import Safe from "assets/icons/safe.svg"
import Thunderbolt from "assets/icons/thunderbolt.svg"

import { useStaticQuery, graphql } from "gatsby"

import styles from "./results.module.css"

const percent = new Intl.NumberFormat("pt-BR", {
  style: "percent",
})

const decimal = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
})

const Results = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            indicators {
              whyReasons
              maxEconomy
              NPS
            }
          }
        }
      }
    `
  )

  return (
    <section className={styles.results}>
      <div className="wrapper">
        <h2>Resultados</h2>
        <div className={styles.findings}>
          <div>
            <Health className={styles.icon} />
            <h3>Finanças saudáveis</h3>
            <p>
              {percent.format(site.siteMetadata.indicators.whyReasons)} de todas
              as operações de{" "}
              <Link to="/produtos/antecipacao-de-salario">
                antecipação de salário
              </Link>{" "}
              ou{" "}
              <Link to="/produtos/credito-consignado">crédito consignado</Link>{" "}
              acontecem para quitar dívidas ou resolver emergências
            </p>
          </div>
          <div>
            <Safe className={styles.icon} />
            <h3>Economia</h3>
            <p>
              Alguns clientes da Facio já economizaram até{" "}
              <strong>
                {decimal.format(site.siteMetadata.indicators.maxEconomy)}
              </strong>{" "}
              ao refinanciar empréstimos predatórios de bancos e financeiras
            </p>
          </div>
          <div>
            <Thunderbolt className={styles.icon} />
            <h3>Experiência do trabalhador</h3>
            <p>
              Os colaboradores adoram a Facio e o nosso NPS dentro das empresas
              é de {percent.format(site.siteMetadata.indicators.NPS)}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Results
